import compose from 'react-hooks-compose'

import { useUsuarioPageAsideLogic } from './useLogic'
import { UsuarioPageAsidePresenter } from './presenter'

export const UsuarioPageAside = compose(props => ({
	useLogic: () => useUsuarioPageAsideLogic(props),
}))(UsuarioPageAsidePresenter)
